import { endpointConst } from "./cacheLayerConstants";

const burstCacheConfig = {
  // [endpointConst.getEarliestDeliveryDays]: [endpointConst.productList],
};

const cmsConfig = {
  [endpointConst.appBannerData]: true,
  [endpointConst.ctDisabledEvents]: true,
  [endpointConst.nudgeCityList]: true,
  [endpointConst.getIntDeliveryForRakhi]: true,
  [endpointConst.dynamicSearchPlaceholder]: true,
  [endpointConst.lottieIcons]: true,
  [endpointConst.saleNudge]: true,
  [endpointConst.trendingProducts]: true,
  [endpointConst.currencyList]: true,
  [endpointConst.showFreeDeliveryTagForPdp]: true,
  [endpointConst.accuracyWeightage]: true,
  default: false,
};

const cacheConfig = {
  [endpointConst.appBannerData]: {
    ttl: 1800000, // 30 minutes
  },
  [endpointConst.geojs]: {
    ttl: 1200000, // 20 minutes
  },
  [endpointConst.ctDisabledEvents]: {
    ttl: 3600000, // 1 hour
  },
  [endpointConst.nudgeCityList]: {
    ttl: 604800000, // 7 days
  },
  [endpointConst.getIntDeliveryForRakhi]: {
    ttl: 900000, // 15 minutes
  },
  [endpointConst.dynamicSearchPlaceholder]: {
    ttl: 3600000, // 1 hour
  },
  [endpointConst.lottieIcons]: {
    ttl: 86400000, // 1 day
  },
  [endpointConst.saleNudge]: {
    ttl: 86400000, // 1 day
  },
  [endpointConst.currencyList]: {
    ttl: 1800000, // 30 minutes
  },
  [endpointConst.showFreeDeliveryTagForPdp]: {
    ttl: 1800000, // 30 minutes
  },
  [endpointConst.accuracyWeightage]: {
    expireAtEndOfDay: true, // valid for the current local date only
  },
  default: {
    ttl: 900000,
  },
};

export { burstCacheConfig, cacheConfig, cmsConfig };
